var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-overlay" }, [
    _c("div", { staticClass: "modal" }, [
      _c("h3", { staticClass: "main-title" }, [
        _vm._v("Please include the following information")
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.handleSubmit($event)
            }
          }
        },
        [
          _vm._l(_vm.extraInputs, function(input) {
            return _c(
              "div",
              { key: input.name, staticClass: "form-group" },
              [
                _c("label", { attrs: { for: input.name } }, [
                  _vm._v(_vm._s(input.label || input.name))
                ]),
                _vm._v(" "),
                ["text", "number", "color"].includes(input.type)
                  ? [
                      input.type === "checkbox"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData[input.name],
                                expression: "formData[input.name]"
                              }
                            ],
                            attrs: {
                              id: input.name,
                              placeholder: input.placeholder,
                              required: input.required,
                              type: "checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.formData[input.name])
                                ? _vm._i(_vm.formData[input.name], null) > -1
                                : _vm.formData[input.name]
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.formData[input.name],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.formData,
                                        input.name,
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.formData,
                                        input.name,
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.formData, input.name, $$c)
                                }
                              }
                            }
                          })
                        : input.type === "radio"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData[input.name],
                                expression: "formData[input.name]"
                              }
                            ],
                            attrs: {
                              id: input.name,
                              placeholder: input.placeholder,
                              required: input.required,
                              type: "radio"
                            },
                            domProps: {
                              checked: _vm._q(_vm.formData[input.name], null)
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.formData, input.name, null)
                              }
                            }
                          })
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData[input.name],
                                expression: "formData[input.name]"
                              }
                            ],
                            attrs: {
                              id: input.name,
                              placeholder: input.placeholder,
                              required: input.required,
                              type: input.type
                            },
                            domProps: { value: _vm.formData[input.name] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  input.name,
                                  $event.target.value
                                )
                              }
                            }
                          })
                    ]
                  : input.type === "textarea"
                  ? [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData[input.name],
                            expression: "formData[input.name]"
                          }
                        ],
                        attrs: {
                          id: input.name,
                          placeholder: input.placeholder,
                          required: input.required
                        },
                        domProps: { value: _vm.formData[input.name] },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.formData,
                              input.name,
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                input.type === "select"
                  ? [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formData[input.name],
                              expression: "formData[input.name]"
                            }
                          ],
                          attrs: { id: input.name, required: input.required },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.formData,
                                input.name,
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _vm._l(input.options, function(option) {
                            return _c(
                              "option",
                              {
                                key: option.value,
                                domProps: { value: option.value }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(option.label) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          input.others
                            ? _c("option", { attrs: { value: "__other__" } }, [
                                _vm._v("Other (please specify)")
                              ])
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.formData[input.name] === "__other__"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData[input.name + "_other"],
                                expression: "formData[input.name + '_other']"
                              }
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "Please specify " + input.label,
                              required: input.required
                            },
                            domProps: {
                              value: _vm.formData[input.name + "_other"]
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  input.name + "_other",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm._m(0)
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-actions" }, [
      _c(
        "button",
        {
          staticClass: "happybox-button green border",
          attrs: { type: "submit" }
        },
        [_vm._v("Submit")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }